import { FC } from "react";
import { Stack } from "capitalrx-components-2.0/lib/layout";
import { PharmacyForm } from "@/components";
import styles from "./PharmacyComms.module.scss";


export const PharmacyComms: FC = () => {

  return (
    <div className={styles.PharmacyPanelContainer}>
      <Stack spacing="large">
        <PharmacyForm />
      </Stack>
    </div>
  );
};

export default PharmacyComms;
